import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { differenceInMilliseconds, isValid } from 'date-fns'
import { setCookie } from 'modules/login/helpers/cookie/cookie'
import { IToken } from 'modules/login/helpers/token/token'
import { TAuthSlice, User } from 'modules/login/types'

const initialState = {
  inLoading: 0,
  validUntil: 0,
  refreshToken: '',
  token: '',
  user: {
    phone: ''
  }
} as TAuthSlice

export const getDecodedTokenPayload = (token?: string): IToken | undefined => {
  if (!token) {
    return
  }

  const payload = token.split('.')[1]

  return payload ? JSON.parse(window.atob(payload)) : undefined
}
export const getDelay = (date: number | string, delta: number): number | undefined => {
  if (isValid(new Date(date))) {
    return differenceInMilliseconds(new Date(date), new Date()) - delta * 60 * 1000
  }
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuthStore: (state) =>
      ({
        validUntil: 0,
        inLoading: state.inLoading,
        refreshToken: '',
        token: '',
        user: {
          phone: state.user?.phone || ''
        }
      }) as TAuthSlice,
    setUserPhone: (state, { payload: phone }: PayloadAction<string>) => {
      if (state.user) {
        state.user.phone = phone
      }
    },
    setInLoading: (state, { payload }: PayloadAction<boolean>) => {
      if (payload) {
        state.inLoading += 1
      } else if (state.inLoading !== 0) {
        state.inLoading -= 1
      }
    },
    setUserData: (state, { payload }: PayloadAction<User>) => {
      state.user = payload
    },
    setAuthInfo: (
      state,
      {
        payload: { refreshToken, token, validUntil }
      }: PayloadAction<Pick<TAuthSlice, 'refreshToken' | 'token' | 'validUntil'>>
    ) => {
      setCookie({
        name: 'token',
        value: token,
        expires: new Date(validUntil)
      })
      setCookie({
        name: 'validUntil',
        value: String(validUntil),
        expires: new Date(validUntil)
      })
      setCookie({
        name: 'refreshToken',
        value: refreshToken,
        expires: new Date(validUntil)
      })

      state.refreshToken = refreshToken
      state.token = token
      state.validUntil = validUntil
    }
  }
})

export const authReducer = authSlice.reducer

export const authActions = authSlice.actions
